import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import image from "./header.jpg";
import PreLoader from "../pre-loader/Preloader";
import { getConfig } from "../../services/environment";
import '../Pages/responsive.css';

// const useStyles = makeStyles({
//   img: {
//     width: "100%",
//     height:"180px",
//     // height:'100%',
//     objectFit:"fill",
//     // objectFit: "cover",
//   },
// });



const Header = (props) => {
  // const classes = useStyles();
  const StylingItem = props;
  return (
    <>
      {/* <div style={{ backgroundColor: StylingItem && StylingItem.StylingItem?.headerColor,height:'180px', width: '100%' }}>
        {StylingItem?.StylingItem?.headerImage && <img src={StylingItem && `${getConfig.baseUrl}${StylingItem.StylingItem.headerImage.uri}`} className={classes.img} />}
      </div> */}

      <div className="img101" style={{ backgroundColor: StylingItem && StylingItem.StylingItem?.headerColor}}>
        {StylingItem?.StylingItem?.headerImage && <img src={StylingItem && `${getConfig.baseUrl}${StylingItem.StylingItem.headerImage.uri}`} alt="Header image" className='img100' />}
      </div>
      <PreLoader />
    </>
  );
};
export default Header;
